module.exports = __webpack_public_path__ + "img/icon_bianji_blue.6c15526e.svg";